export default __webpack_public_path__ + "static/media/plus_icon.972005e7.svg";